// @flow
import React from 'react';
import { escapeForUrl } from 'lib/common';

import './CategoryNavItem.scss';

type Props = {
  name: string,
};

const CategoryNavItem = ({ name }: Props) => {
  const locateToTheItem = () => {
    window.location.href = `/categories#${escapeForUrl(name)}`;
    const nav = document.getElementById(name);
    window.scrollTo({ top: nav.offsetTop, behavior: 'smooth' });
  };

  return (
    <a className="CategoryNavItem hover" onClick={locateToTheItem}>
      <div className="name">{name}</div>
    </a>
  );
};

export default CategoryNavItem;



// WEBPACK FOOTER //
// ./src/components/categories/CategoryNavItem/CategoryNavItem.js